export default __webpack_public_path__ + "static/media/Bar-chart.2a72c676.jpg";